/* eslint-disable */
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../../../components/Button'
import { connect, type ConnectedProps, useSelector, useDispatch } from 'react-redux'
import { type RootState } from '../../../../store'
import { type OperationPermissionState } from '../../../dashboard/redux/operationPermissionSlice'
import { useAuth } from 'react-oidc-context'
import { getOperationPermissions } from '../../../dashboard/redux/actionCreator'
import Link from '@mui/material/Link'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import ArrowBackIos from '@mui/icons-material/ArrowBackIos'
import Typography from '@mui/material/Typography'
import LanguageStrings from '../../../../i18n/locales'
import AddSiteDummy from '../../../../assets/AddSite.png'
import Modal from '../../../../components/Modal'
import { CircularProgress } from '@mui/material'
import { APIConfiguration } from '../../../../utils/apiConfiguration'
import { isValidSiteData } from '../../../../utils/validator'
import { type UpdateSiteState } from '../../redux/updateSiteSlice'
import { reset } from '../../redux/updateSiteSlice'
import { type ImageUploadState } from '../../redux/imageUploadSliceSite'
import { type ImageUploadPostRequest } from '../../services/imageUploadService'
import AuthError from "../../../../components/ErrorComponents/AuthError"
import SiteInformation from './SiteInformation'
import { updateSite, imageUpload, fetchSiteInfo, downloadImage } from '../../redux/actionCreators'
import { type SiteInfoState } from '../../redux/siteInfoSlice'
import { type DownloadImageState } from '../../redux/downloadImageSliceSite'
import { type UpdateSitePutRequest } from '../../services/updateSiteService'
import { ImageUploadReset } from '../../redux/imageUploadSliceSite'
import { siteInfoReset } from '../../redux/siteInfoSlice'
import useRefreshHamburgNotifier from '../../../../customHooks/useRefreshHamburgNotifier'

const httpStatus = APIConfiguration
const MAX_LENGTH = 100
const AddDeviceStrings = LanguageStrings().SiteManagementCollectionStrings.AddSiteComponent
const DashboardStrings = LanguageStrings().Dashboard

const EditSite = (props: PropsFromRedux): JSX.Element => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const operationPermissions: OperationPermissionState = useSelector(
    (state: RootState) => state.operationPermissions
  )
  const { siteIdParam } = useParams() as { siteIdParam: string };
  const [previewImage, setPreviewImage] = React.useState<any>(AddSiteDummy)
  const [siteImage, setSiteImage] = React.useState<any>(null)
  const [siteId, setSiteId] = React.useState<any>('')
  const [siteName, setSiteName] = React.useState('')
  const [siteNameErrorInit, setSiteNameErrorInit] = React.useState(false)
  const [description, setDescription] = React.useState('')
  const [descriptionErrorInit, setDescriptionErrorInit] = React.useState(false)
  const [showConfirmation, setShowConfirmation] = React.useState(false)
  const [showCreatePopup, setShowCreatePopup] = React.useState(false)
  const [showImagePopup, setShowImagePopup] = React.useState(false)
  const auth = useAuth()
  const { refreshHamburgAction } = useRefreshHamburgNotifier()

  React.useEffect(() => {
    // istanbul ignore else
    if (!operationPermissions.updated) {
      props.getOperationPermissions(auth.user?.profile.sub as string)
    }
    props?.fetchSiteInfo(siteIdParam)
    props?.downloadImage(siteIdParam, 'en_US')
  }, [])

  React.useEffect(() => {
    setSiteId(props?.siteInfo?.siteInfo?.id)
    setSiteName(props?.siteInfo?.siteInfo?.siteName || "");
    setDescription(props?.siteInfo?.siteInfo?.description || "");
  }, [props?.siteInfo?.siteInfo?.siteName]);

  React.useEffect(() => {
    // istanbul ignore else
    if (props?.downloadImageState?.downloadImage?.binaryData !== '') {
      setPreviewImage(props?.downloadImageState?.downloadImage?.binaryData)
    }
  }, [props?.downloadImageState?.downloadImage?.binaryData])

  React.useEffect(() => {
    // istanbul ignore next
    if (props.updateSiteState.data !== undefined && props.updateSiteState.data.id) {
      refreshHamburgAction('Site', 'Update')
      if (siteImage) {
        setShowCreatePopup(false)
        setShowImagePopup(true)
        props.imageUpload({siteId: siteId, locale: 'en_US', file: siteImage})
      }
    }
  }, [props.updateSiteState])

  React.useEffect(() => {
    return () => {
      setSiteId('');
      setSiteName('');
      setSiteNameErrorInit(false);
      setDescription('');
      setDescriptionErrorInit(false);
      setPreviewImage(AddSiteDummy);
      setSiteImage(undefined);
      dispatch(ImageUploadReset())
      dispatch(reset());
      dispatch(siteInfoReset());
    };
  }, []);

  function handleBreadCrumbsClick(
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void {
    event.preventDefault()
  }
  const handeleCancelClick = (): void => {
    navigate('/site-list')
  }
  const handleUpdateSite = (): void => {
    const postData = {
      id: siteId,
      siteName: siteName,
      description: description
    }
    props.updateSite(postData)
  }

  // istanbul ignore next
  const handleUpdateSiteWithFailure = (): JSX.Element => {
    if (props.updateSiteState.isLoading === false && props.updateSiteState.httpStatus === httpStatus.CREATED_HTTP_STATUS) {
      return (
        <Modal buttonTypeNegative='hollow' title={AddDeviceStrings.SuccessfullyUpdated} LabelPositive={AddDeviceStrings.OKAY}
          onClickPositive={() => { setShowCreatePopup(false), handeleCancelClick() }}
          onClose={() => { setShowCreatePopup(false), handeleCancelClick() }}>
          <p style={{ paddingTop: '1.2em' }}>{AddDeviceStrings.SiteHasBeenUpdated}</p>
        </Modal>
      )
    } else if (props.updateSiteState.isLoading) {
      return (
        <Modal title={AddDeviceStrings.UpdatingSite}>
          <div className='CircularprogressAmi'><CircularProgress /></div>
        </Modal>
      )
    } else if (props.updateSiteState.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }} onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.updateSiteState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.updateSiteState.httpStatus === httpStatus.INTERNAL_SERVER_ERROR || props.updateSiteState.httpStatus === httpStatus.CONFLICT_ERROR) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }} onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.updateSiteState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.updateSiteState.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError"><AuthError errorMessage="Unauthorized" /></div>
      )
    } else {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }}
          onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {AddDeviceStrings.UpdateSiteError} </p>
        </Modal>
      )
    }
  }
  // istanbul ignore next
  const handleSiteImageWithFailure = (): JSX.Element => {
    if (props.imageUploadState.isLoading === false && props.imageUploadState.httpStatus === httpStatus.CREATED_HTTP_STATUS) {
      return (
        <Modal buttonTypeNegative='hollow' title={AddDeviceStrings.SuccessfullyUpdated} LabelPositive={AddDeviceStrings.OKAY}
          onClickPositive={() => { setShowImagePopup(false), handeleCancelClick() }}
          onClose={() => { setShowImagePopup(false), handeleCancelClick() }}>
          <p style={{ paddingTop: '1.2em' }}>{AddDeviceStrings.SiteHasBeenUpdated}</p>
        </Modal>
      )
    } else if (props.imageUploadState.isLoading) {
      return (
        <Modal title={AddDeviceStrings.UpdatingSite}>
          <div className='CircularprogressAmi'><CircularProgress /></div>
        </Modal>
      )
    } else if (props.imageUploadState.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowImagePopup(false) }} onClose={() => { setShowImagePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.imageUploadState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.imageUploadState.httpStatus === httpStatus.INTERNAL_SERVER_ERROR || props.imageUploadState.httpStatus === httpStatus.CONFLICT_ERROR) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowImagePopup(false) }} onClose={() => { setShowImagePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.imageUploadState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.imageUploadState.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError"><AuthError errorMessage="Unauthorized" /></div>
      )
    } else {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowImagePopup(false) }}
          onClose={() => { setShowImagePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {AddDeviceStrings.UpdateSiteError} </p>
        </Modal>
      )
    }
  }

  const isSiteNameNotValid = (): boolean => {
    return (
      !isValidSiteData(siteName) || siteName.length > 20
    )
  }
  const isDescriptionNotValid = (): boolean => {
    return (
      !isValidSiteData(description) || description.length > MAX_LENGTH
    )
  }
  const shouldDisableAddButton = (): boolean => {
    return (isSiteNameNotValid() || isDescriptionNotValid())
  }

  return (
    <div>
      <div role="presentation" data-testid="breadcrumbs" onClick={handleBreadCrumbsClick} className="AmiHeading">
        <ArrowBackIos className="assetmgmtli" data-testid="breadcrumb-arrow-back" aria-label="navArrow" sx={{ marginTop: '10px' }}
          onClick={() => { navigate(-1) }}
        />
        <Breadcrumbs aria-label="breadcrumb" sx={{ color: '#f0f0f0', fontSize: '12px', marginBottom: '14px', fontFamily: 'Honeywell Sans Web', marginTop: '12px' }}>
          <Link aria-label="navBreadcrumb" className="assetmgmtli" data-testid="bc-link-1" underline="none" color="inherit" onClick={() => { navigate('/thermal-dashboard') }}>
            {DashboardStrings.HOME}
          </Link>
          <Link aria-label='navBreadcrumb' className='assetmgmtli' data-testid="bc-link-2" underline='none' color='inherit' onClick={() => { navigate('/site-list') }} >
            {DashboardStrings.SiteManagement}
          </Link>
          <Typography color="inherit" sx={{ fontSize: '12px', fontFamily: 'Honeywell Sans Web' }}>
            {DashboardStrings.EditSite}
          </Typography>
        </Breadcrumbs>
      </div>
      <div className="ArrowDeviceAdd">
        <div>
          <span data-testid="deviceHistoryDetails" className="deviceMgtDevicelist" style={{ fontSize: '20px', fontWeight: '900', fontStyle: 'normal', lineHeight: '32px', }}>
            {AddDeviceStrings.EditSite}
          </span>
        </div>
      </div>
      <div>
        <SiteInformation 
          siteName={siteName} setSiteName={setSiteName} siteNameErrorInit={siteNameErrorInit} setSiteNameErrorInit={setSiteNameErrorInit}
          description={description} setDescription={setDescription} descriptionErrorInit={descriptionErrorInit} setDescriptionErrorInit={setDescriptionErrorInit}
          previewImage={previewImage} setPreviewImage={setPreviewImage} siteImage={siteImage} setSiteImage={setSiteImage}
          siteId={siteId}
        />
      </div>
      <div style={{
        height: '80px', backgroundColor: '#272727', margin: '150px 0 10px 0', borderRadius: 10, display: 'flex',
        justifyContent: 'space-between', alignItems: 'center', padding: '0 1em'
      }}
      >
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          <Button className='AddDeviceCancelButton' dataTestId="cancel-btn-click" onClick={() => { handeleCancelClick() }}>
            {AddDeviceStrings.Cancel}
          </Button>
          <Button
            className={
              /* istanbul ignore next */
              `${shouldDisableAddButton() ? 'btn-disabled' : ''}`
            } dataTestId="add-site-btn"
            onClick={() => { setShowConfirmation(true) }}
            disabled={shouldDisableAddButton()}
          >
            {AddDeviceStrings.Update}
          </Button>
        </div>
      </div>
      {showConfirmation &&
        <Modal buttonTypeNegative='hollow' title={AddDeviceStrings.UpdateSite} 
          LabelNegative={AddDeviceStrings.Cancel} LabelPositive={AddDeviceStrings.Confirm} 
          onClickPositive={() => {
            setShowConfirmation(false), setShowCreatePopup(true), handleUpdateSite()
          }} onClose={() => { setShowConfirmation(false) }} onClickNegative={() => { setShowConfirmation(false) }}>
          <p style={{ paddingTop: '2.2em' }}>{AddDeviceStrings.SiteUpdateConfirmation}</p>
        </Modal>
      }
      {
        /* istanbul ignore next */
        showCreatePopup && handleUpdateSiteWithFailure()
      }
      {
        /* istanbul ignore next */
        showImagePopup && handleSiteImageWithFailure()
      }
    </div>
  )
}

interface DispatchToProps {
  getOperationPermissions: (sub: string) => void
  fetchSiteInfo: (siteId: string) => void
  downloadImage: (siteId: string, locale: string) => void
  updateSite: (updateSitePutRequest: UpdateSitePutRequest) => void
  imageUpload: (imageUploadPostRequest: ImageUploadPostRequest) => void
}
const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub)),
  fetchSiteInfo: (siteId: string) => dispatch(fetchSiteInfo(siteId)),
  downloadImage: (siteId: string, locale: string) => dispatch(downloadImage(siteId, locale)),
  updateSite: (updateSitePutRequest: UpdateSitePutRequest) => dispatch(updateSite(updateSitePutRequest)),
  imageUpload: (imageUploadPostRequest: ImageUploadPostRequest) => dispatch(imageUpload(imageUploadPostRequest))
})

interface StateToProps {
  updateSiteState: UpdateSiteState,
  imageUploadState: ImageUploadState,
  siteInfo: SiteInfoState,
  downloadImageState: DownloadImageState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  updateSiteState: state.updateSiteState,
  imageUploadState: state.imageUploadStateSite,
  siteInfo: state.siteInfoState,
  downloadImageState: state.downloadImageSiteState
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(EditSite)
